import { render, staticRenderFns } from "./component-color-selector.vue?vue&type=template&id=2451d6aa&scoped=true"
import script from "./component-color-selector.vue?vue&type=script&lang=js"
export * from "./component-color-selector.vue?vue&type=script&lang=js"
import style0 from "./component-color-selector.vue?vue&type=style&index=0&id=2451d6aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2451d6aa",
  null
  
)

export default component.exports